// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2gqgo","buttons":"RemoveExpirationActionButtons_buttons__2LVWv"};